<template>
  
  <listing-layout :style="{ '--apperances-color': computedColor }" no-sm-padding>
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="nominate__title h2 mb-3">{{ draft && draft.name ? draft.name : '' }}</h1>
    </div>
    <div slot="content" class="leaders">
      <div class="alert alert-warning" v-if="error">{{ error }}</div>
        <div class="alert alert-success" v-if="success">{{success}}</div>

        <appearances-drafts-header :appearances="appearances" />

        <statistics v-if="statistics" :statistics="statistics" :appearances="appearances" />

        <round-tabs :tabs="tabs" :is-main="true" />

        <draft-events-list v-if="draft && currentTab === tabs[0].name" :appearances="appearances" />
        <draft-riders-list v-if="draft && currentTab === tabs[1].name" :appearances="appearances" />
        <search v-if="draft && currentTab === tabs[2].name" :appearances="appearances" />

        <div class="footer">
          <!-- need add banner -->
        </div>
    </div>
  </listing-layout>
</template>

<script>
import listingLayout from '@/components/ListingLayout'
import getAppearances from './mixins/getAppearances'
import AppearancesDraftsHeader from './components/AppearancesDraftsHeader'
import AppearancesDraftsDesktopBanner from './components/AppearancesDraftsDesktopBanner'
import getStatistics from './mixins/getStatistics'
import Statistics from './components/Statistics'
import DraftEventsList from './components/DraftEventsList'
import DraftRiderstList from './components/DraftRidersList'
import RoundTabs from './components/RoundTabs'
import search from './components/Search'
import fetchData from '../../../mixins/apiHelpers'

export default {
  name: 'LeadersDraft',
  mixins: [getAppearances, getStatistics],
  props: ['success'],
  computed: {
    entity() {
      return {
        model: 'draft',
        id: this.$route.params.draft_id
      }
    },
    computedColor() {
      return this.appearances && this.appearances.schema_color
        ? `${this.appearances.schema_color}`
        : 'var(--primary)'
    }
  },
  watch: {
    '$route.query.tab': {
      immediate: true,
      handler(tab) {
        const newTab = tab ? tab.toLowerCase() : this.tabs[0].name
        const newQuery = {}
        switch (newTab) {
          case 'search':
            newQuery.select = this.$route.query?.select
            newQuery.id = this.$route.query?.id
            break
          case 'riders':
            newQuery.page = this.$route.query?.page
            break
          default:
            break
        }
        newQuery.tab = newTab

        const queryChanged =
          JSON.stringify(this.$route.query) !== JSON.stringify(newQuery)

        if (queryChanged) {
          this.$router.replace({ query: newQuery }).catch(() => {})
        }

        this.currentTab = newTab
        this.fetchTabContent(tab)
      }
    }
  },
  components: {
    AppearancesDraftsHeader,
    AppearancesDraftsDesktopBanner,
    'listing-layout': listingLayout,
    Statistics,
    'draft-events-list': DraftEventsList,
    'draft-riders-list': DraftRiderstList,
    'round-tabs': RoundTabs,
    search
  },
  data() {
    const tabs = [
      { name: 'leaderboard' },
      { name: 'riders' },
      { name: 'search' }
    ]
    return {
      draft: null,
      error: null,
      options: {
        loaded: false
      },
      tabs,
      currentTab: null
    }
  },
  provide() {
    return {
      entity: this.entity
    }
  },
  async mounted() {
    const draft = this.draft || await this.fetchDraft()

    if (draft && !this.statistics) {
      await this.fetchStatistics()
      this.fetchTabContent(this.$route.query.tab || this.tabs[0].name)
    }
  },
  methods: {
    fetchTabContent(tabName) {
      if (!this.error) {
        this.currentTab = tabName
      }
    },
    formatDate(dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      })
    },
    async fetchDraft() {
      await fetchData(`${this.$api}/leaders/drafts/${this.entity.id}`, (response) => {
        this.draft = response.data.data.draft
      }, this)
      return this.draft
    }
  }
}
</script>
<style scoped>
  .nominate__title {
    color: var(--apperances-color) !important;
  }

  .nominate__click {
    border-color: 2px solid var(--apperances-color) !important;
    color: var(--apperances-color) !important;
    background-color: white !important;
  }

  .nominate__click:hover {
    color: white !important;
    background-color: var(--apperances-color) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Leaders/Listing/Draft.vue